import React, { useState } from 'react';
import { Box, Button, TextField, Typography, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import LoadingError from './LoadingError';
import TopBanner from './TopBanner';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    
    try {
      const response = await fetch(`${apiUrl}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
        credentials: 'include', // Required for cookies
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.msg || 'Invalid credentials');
      }

      // Force full page reload to establish session
      navigate('/confirm');
      
    } catch (error) {
      setError(error.message || 'An error occurred');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ paddingTop: "84px" }}>
      <TopBanner /> {/* Your top banner */}
      <Box
        sx={{
          maxWidth: 400,
          margin: '0 auto',
          padding: 4,
          borderRadius: 2,
          boxShadow: 3,
          backgroundColor: 'background.paper', // To maintain a consistent background
        }}
      >
        <Typography variant="h5" gutterBottom textAlign="center">
          Login
        </Typography>

        

        <form onSubmit={handleLogin}>
          <TextField
            fullWidth
            label="Email"
            variant="outlined"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            margin="normal"
          />
          <TextField
            fullWidth
            label="Password"
            variant="outlined"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            margin="normal"
          />

          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            disabled={loading}
            sx={{ marginTop: 2 }}
          >
            {loading ? (
              <CircularProgress size={24} sx={{ color: 'white' }} />
            ) : (
              'Login'
            )}
          </Button>
        </form>

        {error && (
          <Typography color="error" sx={{ marginTop: 2, textAlign: 'center' }}>
            {error}
          </Typography>
        )}

        {/* Disclaimer or Terms & Conditions */}
        <Box sx={{ marginTop: 2, textAlign: 'center' }}>
          <Typography variant="body2" color="textSecondary">
            By logging in, you agree to our{' '}
            <Button
              sx={{ padding: 0, textTransform: 'none' }}
              onClick={() => window.open('https://ciitainc.com/privacy-policy/', '_blank')}
            >
              Privacy Policy
            </Button>{' '}
          </Typography>
        </Box>
      </Box>
    </div>
  );
};

export default Login;
